import React from "react";

const StylingPreview = () => {
	return (
		<div className="w-2/3 flex flex-col items-center justify-start pt-8 space-y-6">
			{/* Phone Mockup with Iframe */}
			<div className="bg-white border-8 border-black rounded-[2.5rem] w-[360px] h-[700px] overflow-hidden shadow-lg">
				<iframe
					id="preview-frame"
					src="https://staging.scan.swanvision.ai/?shop_domain=idntfy&scan_type=clothing_custom_fit_scan&store_name=idntfy&shopify_redirect=https://myknitever.myshopify.com"
					className="w-full h-full rounded-[2rem] border-none"
					title="App Preview"
				/>
			</div>

			{/* Navigation Buttons */}
			<div className="flex items-center justify-between w-[360px] mt-4">
				<button className="px-5 py-2 rounded-xl bg-gray-200 text-gray-700 text-sm font-medium hover:bg-gray-300 transition">← Prev</button>
				<button className="px-5 py-2 rounded-xl bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 transition">Next →</button>
			</div>
		</div>
	);
};

export default StylingPreview;
